import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Import Icons
import { useRole } from "components/Hooks/UserHooks";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import { useTranslation } from "react-i18next";
import { ROUTES } from "routes/allRoutes";
import ImgUser from "../assets/images/menu/user.png";
import ImgSetting from "../assets/images/menu/setting.svg";
import ImgAgency from "../assets/images/menu/agency.png";
import ImgVOC from "../assets/images/menu/voc.svg";
import ImgInquiry from "../assets/images/menu/inquiry.svg";

const Navdata = () => {
  const history = useNavigate();
  const { t } = useTranslation();

  const { userPermissions } = useRole();

  const [menuActive, setMenuActive] = useState<string>("DASHBOARD");

  const [isCurrentState, setIsCurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
  }, [history]);

  const menuItems: any = [
    {
      id: "reservation-user",
      label: t("Pre-Register"),
      icon: <i className="ri-user-star-line" />,
      link: ROUTES.PRE_REGISTER,
      click: function (e: any) {
        setMenuActive((prev) => "PRE_REGISTER");
        setIsCurrentState((prev) => "Pre-Register");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "PRE_REGISTER",
      isShow: true,
    },
    {
      id: "job-post-management",
      label: t("Job Post Management"),
      icon: <i className="ri ri-inbox-line" />,
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "JOB_POST_MANAGEMENT");
        setIsCurrentState((prev) => "JOB_POST_MANAGEMENT");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "JOB_POST_MANAGEMENT",
      isShow: true,
      subItems: [
        {
          id: "job-post-menu",
          label: t("Job Post Menu"),
          link: ROUTES.JOB_POST_MANAGEMENT,
          isShow: isHavePermissionRole(
            [ROLES_FOR_APP.JOB_POST_MANAGEMENT],
            userPermissions
          ),
        },
        {
          id: "plan-management",
          label: t("Plan Menu"),
          link: ROUTES.PLAN_MANAGEMENT,
          isShow: true,
        },
        {
          id: "section",
          label: t("Section Menu"),
          link: ROUTES.SECTION_MANAGEMENT,
          isShow: true,
        },
        {
          id: "banner-position",
          label: t("Banner Position"),
          link: ROUTES.BANNER_POSITON,
          isShow: true,
        },
        {
          id: "payment-history",
          label: t("Payment History"),
          link: ROUTES.USER_PLAN_PURCHASE_LIST,
          isShow: true,
        },
      ],
    },

    {
      id: "application-management",
      label: t("Application Management"),
      icon: <i className="ri-list-check" />,
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "APPLICATION_MANAGEMENT");
        setIsCurrentState((prev) => "APPLICATION_MANAGEMENT");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "APPLICATION_MANAGEMENT",
      isShow: true,
      subItems: [
        {
          id: "applications",
          label: t("Applications"),
          link: ROUTES.APPLICATION_MANAGEMENT,
          isShow: isHavePermissionRole(
            [ROLES_FOR_APP.APPLICATION_MANAGEMENT],
            userPermissions
          ),
        },
        {
          id: "talent",
          label: t("Talent"),
          link: ROUTES.TALENT_MANAGEMENT,
          isShow: isHavePermissionRole(
            [ROLES_FOR_APP.TALENT_MANAGEMENT],
            userPermissions
          ),
        },
      ],
    },

    {
      id: "content-management",
      label: t("Content Management"),
      icon: <i className="ri-draft-line" />,
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "CONTENT_MANAGEMENT");
        setIsCurrentState((prev) => "CONTENT_MANAGEMENT");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "CONTENT_MANAGEMENT",
      isShow: true,
      subItems: [
        {
          id: "content-type",
          label: t("Content Type"),
          link: ROUTES.CONTENT_TYPE,
          isShow: true,
        },
        {
          id: "content",
          label: t("Community"),
          link: ROUTES.CONTENT_MANAGEMENT,
          isShow: true,
        },
        {
          id: "ai-content-approval",
          label: t("Community AI"),
          link: ROUTES.AI_CONTENT_APPROVAL,
          isShow: true,
        },
        {
          id: "ai-content-tbed",
          label: t("Community AI (TBED)"),
          link: ROUTES.AI_CONTENT_TBED,
          isShow: true,
        },
        {
          id: "comments",
          label: t("Comments"),
          link: ROUTES.COMMENT_MANAGEMENT,
          isShow: isHavePermissionRole(
            [ROLES_FOR_APP.COMMENT_MANAGEMENT],
            userPermissions
          ),
        }
      ],
    },
    {
      id: "popup-management",
      label: t("Popup Management"),
      icon: <i className="ri ri-clipboard-fill" />,
      link: ROUTES.POPUP_LIST_MANAGEMENT,
      click: function (e: any) {
        setMenuActive((prev) => "Popup Manager");
        setIsCurrentState((prev) => "Popup Manager");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Popup Manager",
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.POPUP_LIST_MANAGEMENT],
        userPermissions
      ),
    },
    {
      id: "push-notification",
      label: t("Push Notification"),
      icon: <i className="ri-notification-2-line" />,
      link: "/#",
      isShow: true,
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "Push Notification");
        setIsCurrentState((prev) => "Push Notification");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Push Notification",
      subItems: [
        {
          id: "push-log",
          label: t("Push Log"),
          link: ROUTES.PUSH_NOTIFICATION_PUSH_LOG,
          isShow: true,
        },
        {
          id: "manual-push",
          label: t("Send Push (Manual)"),
          link: ROUTES.PUSH_NOTIFICATION_MANUAL_PUSH,
          isShow: true,
        },
      ],
    },
    {
      id: "user-management",
      label: t("User Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgUser}
          alt="User Management"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "User");
        setIsCurrentState((prev) => "User");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "User",
      isShow: true,
      subItems: [
        {
          id: "job-seeker",
          label: t("Job Seekers"),
          link: ROUTES.USER_JOB_SEEKER,
          isShow: true,
        },
        {
          id: "job-seeker-virtual",
          label: t("Job Seekers (Virtual)"),
          link: ROUTES.USER_JOB_SEEKER_VIRTUAL,
          isShow: true,
        },
        {
          id: "recruiter",
          label: t("Recruiters"),
          link: ROUTES.USER_RECRUITER,
          isShow: true,
        },
        {
          id: "recruiter-virtual",
          label: t("Recruiter (Virtual)"),
          link: ROUTES.USER_RECRUITER_VIRTUAL,
          isShow: true,
        },
      ],
    },
    {
      id: "agency-management",
      label: t("Agency Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgAgency}
          alt="Agency Management"
          width={18}
          height={18}
        />
      ),
      link: ROUTES.AGENCY_LIST_MANAGEMENT,
      click: function (e: any) {
        setMenuActive((prev) => "Agency");
        setIsCurrentState((prev) => "Agency");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Agency",
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.AGENCY_LIST_MANAGEMENT],
        userPermissions
      ),
    },
    {
      id: "administrator-management",
      label: t("Administrator Management"),
      icon: <i className="ri-user-add-line" />,
      link: ROUTES.OPERATOR_LIST,
      click: function (e: any) {
        setMenuActive((prev) => "OPERATOR_LIST");
        setIsCurrentState((prev) => "Administrator Management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "OPERATOR_LIST",
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.OPERATOR_LIST],
        userPermissions
      ),
    },
    {
      id: "operations-management",
      label: t("Operator Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgVOC}
          alt="Notification"
          width={21}
          height={21}
        />
      ),
      link: "/#",
      isShow: true,
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "Operator Management");
        setIsCurrentState((prev) => "Operator Management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Operator Management",
      subItems: [
        {
          id: "notice-management",
          label: t("Notice"),
          link: ROUTES.NOTICE_MANAGEMENT,
          isShow: isHavePermissionRole(
            [ROLES_FOR_APP.NOTICE_MANAGEMENT],
            userPermissions
          ),
        },
        {
          id: "inquiries",
          label: t("Inquiry"),
          link: ROUTES.INQUIRY_LIST,
          isShow: true,
        },
        {
          id: "voc-reasons",
          label: t("VOC Reason"),
          link: ROUTES.VOC_REASON,
          isShow: true,
        },
        {
          id: "voc-list",
          label: t("VOC List"),
          link: ROUTES.VOC_LIST,
          isShow: true,
        },
      ],
    },
    {
      id: "logs",
      label: t("Logs"),
      icon: <i className="ri-history-line" />,
      link: "/#",
      isShow: true,
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "Logs");
        setIsCurrentState((prev) => "Logs");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Logs",
      subItems: [
        {
          id: "event_log",
          label: t("Event Log"),
          link: ROUTES.EVENT_LOG,
          isShow: true,
        },
        {
          id: "resume-view-log",
          label: t("Resume View Log"),
          link: ROUTES.RESUME_VIEW_LOG,
          isShow: true,
        },
        {
          id: "manual-push",
          label: t("Adult Verify Log"),
          link: ROUTES.ADULT_VERIFY_LOG,
          isShow: true,
        },
      ],
    },
    {
      id: "setting-management",
      label: t("Setting Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgSetting}
          alt="Setting"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "setting-management");
        setIsCurrentState((prev) => "setting-management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "setting-management",
      isShow: true,
      subItems: [
        {
          id: "app_setting",
          label: t("App Setting"),
          link: ROUTES.APP_SETTING,
          isShow: true,
        },
        {
          id: "ai_setting",
          label: t("AI Setting"),
          link: ROUTES.AI_SETTING,
          isShow: true,
        },
      ],
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
